module.exports = {"id":"200353","name":"Adama Soumaoro","rating":"74","photo":"./data/images/photos/3/200353.png","club":{"name":"LOSC","logo":"./data/images/clubs/LOSC.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AdamaSoumaoro0.json
// module id = 88
// module chunks = 0